<template>
    <el-dialog :title="title+'已关联元数据'" width="40%" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" :model="form" ref="form" label-width="140px" :rules="dataRule" v-loading="loading"
                 :disabled="method==='view'" @keyup.enter.native="doSubmit()" @submit.native.prevent>
            <el-form-item label="组件类型：" prop="basicAssemblyId" @change="selBasicAssembly">
                <el-select v-model="form.basicAssemblyId" placeholder="请选择组件类型" filterable class="w100i" clearable>
                    <el-option
                            :key="item.id"
                            :label="item.assemblyName"
                            :value="item.id"
                            v-for="item in basicAssemblyOpt">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="关联元数据：" prop="metadataId">
                <el-select v-model="form.metadataId" placeholder="请选择元数据" filterable class="w100i" clearable>
                    <el-option
                            :key="item.id"
                            :label="item.assemblyName"
                            :value="item.id"
                            v-for="item in basicAssemblyOpt">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="元数据名称：" prop="basicName">
                <el-input v-model.trim="form.basicName" placeholder="请输入元数据名称（限10字）" clearable
                          maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="排序：" prop="sort">
                <el-input-number v-model="form.sort" :min="1"></el-input-number>
            </el-form-item>
            <el-form-item label="组件权限：" prop="viewFlag">
                <el-checkbox v-model="form.viewFlag">可查看</el-checkbox>
                <el-checkbox v-model="form.addFlag">可新增</el-checkbox>
                <el-checkbox v-model="form.editFlag">可编辑</el-checkbox>
            </el-form-item>
            <el-form-item label="是否必填：" prop="dataRequired">
                <el-switch v-model="form.dataRequired" active-value="0" inactive-value="1"></el-switch>
            </el-form-item>
            <el-form-item label="查询条件：" prop="dataSelect">
                <el-switch v-model="form.dataSelect" active-value="0" inactive-value="1"></el-switch>
            </el-form-item>
            <el-form-item label="列表展示：" prop="dataWhere">
                <el-switch v-model="form.dataWhere" active-value="0" inactive-value="1"></el-switch>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                loading: false,
                title: '',
                method: '',
                basicAssemblyOpt: [],
                form: {
                    id: '',
                    basicAssemblyId: "",
                    metadataId: "",
                    basicName: "",
                    sort: "",
                    viewFlag: "",
                    addFlag: "",
                    editFlag: "",
                    dataRequired: '0',
                    dataSelect: '0',
                    dataWhere: '0',
                },
                permissionName: '',
                dataRule: {
                    basicAssemblyId: [
                        {required: true, message: '组件类型不能为空', trigger: 'change'}
                    ],
                    metadataId: [
                        {required: true, message: '关联元数据不能为空', trigger: 'change'}
                    ],
                    basicName: [
                        {required: true, message: '元数据名称不能为空', trigger: 'blur'}
                    ],
                    sort: [
                        {required: true, message: '排序不能为空', trigger: 'blur'}
                    ],
                }
            }
        },
        methods: {
            // 初始化数据
            init(row, method) {
                this.method = method
                if (method === 'add') {
                    this.title = `新增`
                } else if (method === 'edit') {
                    this.title = '修改'
                } else if (method === 'view') {
                    this.title = '查看'
                }
                if (row) {
                    this.form.id = row.id
                } else {
                    this.form.id = ''
                }
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                    this.getBasicAssembly()
                    if (this.method != 'add') {
                        this.getInfo()
                    }
                })
            },
            // 查询详情信息
            getInfo() {
                this.loading = true
                this.$axios(this.api.metadata.getById + '/' + this.form.id).then(res => {
                    if (res.status) {
                        this.form = this.recover(this.form, res.data);
                    }
                    this.loading = false
                })
            },
            // 获取组件类型
            getBasicAssembly() {
                this.$axios(this.api.metadata.selectAllMetadataBasicAssembly).then(res => {
                    if (res.status) {
                        this.basicAssemblyOpt = res.data
                    }
                })
            },
            // 选择组件类型
            selBasicAssembly(val) {
                this.from.metadataId = ''
                this.from.templateId = ''
            },
            // 表单提交
            doSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        let api = this.api.metadata.save, type = 'post'
                        if (this.method === 'edit') {  // 新增
                            api = this.api.metadata.updateById
                            type = 'put'
                        }
                        this.$axios(api, this.form, type).then(data => {
                            if (data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            },
        }
    }
</script>
